module.exports = __webpack_public_path__ + "static/media/clinician-blood-thinner-table-preview@3x.22fa68d6.png";